import { createSetType } from "../actionHelpers";

export const QUERY_STRING_SET = createSetType("QUERY_STRING_SET");
export const QUERY_STRING_SET_REDUX = createSetType("QUERY_STRING_SET_REDUX");
